import { CertificateState } from "@/core/models/certificate";

export default {
  certificates: (state: CertificateState) => state.certifications,
};
